import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const STATUSES = [
    { value: "pending", label: "In attesa" },
    { value: "paid", label: "Pagato" },
    { value: "shipped", label: "Spedito" },
    { value: "cancelled", label: "Annullato" },
];

export default function AdminOrders() {
    const [orders, setOrders] = useState([]);
    const [selected, setSelected] = useState(null);

    const load = () => api.get("/admin/orders").then(r => setOrders(r.data));
    useEffect(() => { load(); }, []);

    const update = async (oid, status) => {
        await api.put(`/admin/orders/${oid}`, { status });
        toast.success("Ordine aggiornato");
        load();
    };

    return (
        <div data-testid="admin-orders">
            <div className="overline mb-2">Vendite</div>
            <h1 className="font-display text-4xl text-[color:var(--ms-charcoal)] mb-10">Ordini</h1>

            {orders.length === 0 ? (
                <div className="panel p-16 text-center text-[color:var(--ms-muted)]">Nessun ordine ancora.</div>
            ) : (
                <div className="panel overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="text-left text-[color:var(--ms-muted)] text-xs uppercase tracking-[0.2em]">
                            <tr>
                                <th className="px-4 py-3 border-b border-[color:var(--ms-border)]">N°</th>
                                <th className="px-4 py-3 border-b border-[color:var(--ms-border)]">Email</th>
                                <th className="px-4 py-3 border-b border-[color:var(--ms-border)]">Capi</th>
                                <th className="px-4 py-3 border-b border-[color:var(--ms-border)]">Totale</th>
                                <th className="px-4 py-3 border-b border-[color:var(--ms-border)]">Pagamento</th>
                                <th className="px-4 py-3 border-b border-[color:var(--ms-border)]">Stato</th>
                                <th className="px-4 py-3 border-b border-[color:var(--ms-border)]">Data</th>
                            </tr>
                        </thead>
                        <tbody className="text-[color:var(--ms-charcoal)]">
                            {orders.map(o => (
                                <tr key={o.id} className="border-b border-[color:var(--ms-border)] hover:bg-[color:var(--ms-cream)] cursor-pointer" onClick={() => setSelected(o)} data-testid={`admin-order-${o.id}`}>
                                    <td className="px-4 py-3 font-mono text-xs">{o.id.slice(0, 8)}</td>
                                    <td className="px-4 py-3">{o.email}</td>
                                    <td className="px-4 py-3">{o.items.length}</td>
                                    <td className="px-4 py-3">€{o.total.toFixed(2)}</td>
                                    <td className="px-4 py-3"><span className={`overline ${o.payment_status === "paid" ? "text-[color:var(--ms-sage-dark)]" : "text-[color:var(--ms-muted)]"}`}>{o.payment_status === "paid" ? "Pagato" : "Non pagato"}</span></td>
                                    <td className="px-4 py-3" onClick={e => e.stopPropagation()}>
                                        <select value={o.status} onChange={e => update(o.id, e.target.value)} className="bg-[color:var(--ms-warm-white)] border border-[color:var(--ms-border)] px-2 py-1 text-xs uppercase tracking-wider">
                                            {STATUSES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                                        </select>
                                    </td>
                                    <td className="px-4 py-3 text-[color:var(--ms-muted)] text-xs">{new Date(o.created_at).toLocaleString("it-IT")}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {selected && (
                <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setSelected(null)}>
                    <div className="bg-[color:var(--ms-warm-white)] border border-[color:var(--ms-border)] max-w-2xl w-full p-8" onClick={e => e.stopPropagation()}>
                        <div className="overline">Ordine</div>
                        <h2 className="font-display text-3xl text-[color:var(--ms-charcoal)] font-mono">{selected.id.slice(0, 8)}</h2>
                        <div className="mt-4 text-sm text-[color:var(--ms-muted)]">{selected.email} · {new Date(selected.created_at).toLocaleString("it-IT")}</div>
                        <ul className="mt-6 divide-y divide-[color:var(--ms-border)] border-y border-[color:var(--ms-border)]">
                            {selected.items.map((it, i) => (
                                <li key={i} className="py-3 flex justify-between text-sm">
                                    <span>{it.title} <span className="text-[color:var(--ms-muted)]">· {it.brand} · Taglia {it.size} · x{it.quantity}</span></span>
                                    <span>€{(it.price * it.quantity).toFixed(2)}</span>
                                </li>
                            ))}
                        </ul>
                        <div className="mt-4 space-y-1 text-sm">
                            <div className="flex justify-between text-[color:var(--ms-muted)]"><span>Subtotale</span><span>€{selected.subtotal.toFixed(2)}</span></div>
                            {selected.discount > 0 && <div className="flex justify-between text-[color:var(--ms-terracotta)]"><span>Sconto</span><span>-€{selected.discount.toFixed(2)}</span></div>}
                            <div className="flex justify-between font-medium border-t border-[color:var(--ms-border)] pt-2 mt-2"><span>Totale</span><span>€{selected.total.toFixed(2)}</span></div>
                        </div>
                        {selected.shipping_address?.line1 && (
                            <div className="mt-6 text-sm">
                                <div className="overline mb-1">Indirizzo di spedizione</div>
                                <div>{selected.shipping_address.line1}</div>
                                <div>{selected.shipping_address.city} {selected.shipping_address.postal}</div>
                                <div>{selected.shipping_address.country}</div>
                            </div>
                        )}
                        <button onClick={() => setSelected(null)} className="mt-8 border border-[color:var(--ms-border)] hover:border-[color:var(--ms-charcoal)] px-5 py-3 text-xs tracking-[0.2em] uppercase">Chiudi</button>
                    </div>
                </div>
            )}
        </div>
    );
}
